{
  "PROFILE_SETTINGS": {
    "LINK": "Profileinstellungen",
    "TITLE": "Profileinstellungen",
    "BTN_TEXT": "Profil aktualisieren",
    "DELETE_AVATAR": "Avatar löschen",
    "AVATAR_DELETE_SUCCESS": "Avatar wurde erfolgreich gelöscht",
    "AVATAR_DELETE_FAILED": "Beim Löschen des Avatars ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    "UPDATE_SUCCESS": "Ihr Profil wurde erfolgreich aktualisiert",
    "PASSWORD_UPDATE_SUCCESS": "Ihr Passwort wurde erfolgreich geändert",
    "AFTER_EMAIL_CHANGED": "Ihr Profil wurde erfolgreich aktualisiert. Melden Sie sich erneut an, wenn Ihre Anmeldeinformationen geändert werden",
    "FORM": {
      "PICTURE": "Profilbild",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Bild für E-Mail-Signatur",
        "HINT": "Wird in E-Mail-Signaturen verwendet. {'{{'}email_signature_picture{'}}'} wird durch die URL dieses Bildes ersetzt (kein Bild-Tag) — verwenden Sie sie als Bildquelle (das src-Attribut eines img-Tags) in Ihrer Signatur oder der Postfach-Signatur. Wenn nichts festgelegt ist, wird nichts eingefügt.",
        "DELETE_SUCCESS": "Das Bild für die E-Mail-Signatur wurde erfolgreich gelöscht",
        "DELETE_FAILED": "Beim Löschen des Bildes für die E-Mail-Signatur ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut"
      },
      "AVATAR": "Profilbild",
      "ERROR": "Bitte korrigieren Sie Formularfehler",
      "REMOVE_IMAGE": "Entfernen",
      "UPLOAD_IMAGE": "Bild hochladen",
      "UPDATE_IMAGE": "Bild aktualisieren",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Ihre E-Mail-Adresse ist Ihre Identität und wird zum Anmelden verwendet."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey zum Senden von Nachrichten",
        "NOTE": "Sie können einen Hotkey (entweder Enter oder Cmd/Strg+Enter) basierend auf Ihrer Schreibpräferenz auswählen.",
        "UPDATE_SUCCESS": "Ihre Einstellungen wurden erfolgreich aktualisiert",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Eingabe (↵)",
            "CONTENT": "Senden Sie Nachrichten, indem Sie die Eingabetaste drücken, anstatt auf die Schaltfläche \"Senden\" zu klicken."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Strg + Enter (⌘ + ↵)",
            "CONTENT": "Senden Sie Nachrichten, indem Sie Cmd/Strg + Eingabetaste drücken, anstatt auf die Schaltfläche „Senden“ zu klicken."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Passen Sie das Erscheinungsbild Ihres Dashboards an.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Standard",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Dashboard-Sprache",
          "NOTE": "Überschreiben Sie die Kontosprache für Ihr eigenes Dashboard. Leer lassen, um die Kontostandardeinstellung zu verwenden.",
          "USE_ACCOUNT_DEFAULT": "Kontostandard verwenden",
          "API_SUCCESS": "Ihre Dashboard-Sprache wurde erfolgreich aktualisiert",
          "API_ERROR": "Beim Aktualisieren der Dashboard-Sprache ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Nachrichtensprache",
          "NOTE": "Wählen Sie, ob Originalnachrichten oder deren Übersetzungen angezeigt werden sollen",
          "ORIGINAL": "Original",
          "TRANSLATED": "Übersetzt"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Einfügeverhalten",
          "NOTE": "Wählen Sie, wie eingefügter Inhalt beim Verfassen von Nachrichten verarbeitet werden soll",
          "UPDATE_SUCCESS": "Ihre Einfügeeinstellungen wurden erfolgreich aktualisiert",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Gesamte Formatierung beibehalten",
              "DESCRIPTION": "Beim Einfügen von Inhalten die gesamte Formatierung einschließlich Tabellen, Stilen und anderer HTML-Elemente beibehalten."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Nur Text mit Links",
              "DESCRIPTION": "In reinen Text konvertieren, aber anklickbare Links beim Einfügen erhalten."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Nur reiner Text",
              "DESCRIPTION": "Beim Einfügen die gesamte Formatierung entfernen und in reinen Text konvertieren."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Höhe des Antwortfelds",
          "NOTE": "Legen Sie die Mindesthöhe des Antwortfelds als Prozentsatz der Bildschirmhöhe fest. Gilt nur für E-Mail-Konversationen.",
          "UPDATE_SUCCESS": "Ihre Einstellung für die Höhe des Antwortfelds wurde erfolgreich aktualisiert",
          "PERCENT_LABEL": "Höhe (% der Bildschirmhöhe)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Standard",
              "DESCRIPTION": "Das Antwortfeld beginnt klein und wächst mit der Eingabe."
            },
            "CUSTOM": {
              "HEADING": "Benutzerdefiniert",
              "DESCRIPTION": "Das Antwortfeld hat immer mindestens die gewählte Prozentzahl der Bildschirmhöhe."
            }
          }
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Persönliche Nachrichtensignatur",
        "NOTE": "Erstellen Sie eine einzigartige Nachrichtensignatur, die am Ende jeder Nachricht angezeigt wird, die Sie aus einem beliebigen Posteingang senden. Sie können auch ein Inline-Bild einfügen, das in Live-Chat-, E-Mail- und API-Postfächern unterstützt wird.",
        "BTN_TEXT": "Nachrichten-Signatur speichern",
        "API_ERROR": "Signatur konnte nicht gespeichert werden! Versuch es noch einmal",
        "API_SUCCESS": "Signatur erfolgreich gespeichert",
        "IMAGE_UPLOAD_ERROR": "Bild konnte nicht hochgeladen werden! Versuchen Sie es erneut",
        "IMAGE_UPLOAD_SUCCESS": "Bild erfolgreich hinzugefügt. Bitte klicken Sie auf Speichern, um die Signatur zu speichern",
        "IMAGE_UPLOAD_SIZE_ERROR": "Bildgröße sollte kleiner als {size}MB sein",
        "DESCRIPTION": "Erstellen Sie eine eindeutige Nachrichtensignatur, die am Ende jeder von Ihnen gesendeten E-Mail erscheint. Sie können auch ein Inline-Bild einfügen."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Nachrichten-Signatur",
        "ERROR": "Nachrichten-Signatur darf nicht leer sein",
        "PLACEHOLDER": "Füge hier Deine persönliche Nachrichtensignatur ein."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Passwort",
        "NOTE": "Durch das Aktualisieren Ihres Kennworts werden Ihre Anmeldungen auf mehreren Geräten zurückgesetzt.",
        "BTN_TEXT": "Passwort ändern"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Zugangstoken",
        "NOTE": "Dieses Token kann verwendet werden, wenn Sie eine API-basierte Integration erstellen",
        "COPY": "Kopieren",
        "REGENERATE": "Neu generieren",
        "REGENERATE_SUCCESS": "Zugriffstoken erfolgreich neu generiert. Bitte aktualisieren Sie alle Integrationen, die den alten Token verwenden.",
        "REGENERATE_CONFIRM_TITLE": "Zugriffstoken neu generieren?",
        "REGENERATE_CONFIRM_MESSAGE": "Dadurch wird der aktuelle Token ungültig. Alle Integrationen, die den alten Token verwenden, funktionieren nicht mehr."
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Keine",
          "MINE": "Zugewiesen",
          "ALL": "Alle",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Ereignisse für Konversationen zu alarmieren",
          "NONE": "Keine",
          "ASSIGNED": "Zugewiesene Unterhaltungen",
          "ALL_CONVERSATIONS": "Alle Konversationen"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alarmton:"
        },
        "CONDITIONS": {
          "TITLE": "Alarmbedingungen:",
          "CONDITION_ONE": "Audio-Alarm nur dann senden, wenn das Browserfenster nicht aktiv ist",
          "CONDITION_TWO": "Sende Benachrichtigungen alle 30 Sekunden, bis alle zugewiesenen Unterhaltungen gelesen werden"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Mehr erfahren"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-Mail Benachrichtigungen",
        "NOTE": "Aktualisieren Sie hier Ihre E-Mail-Benachrichtigungseinstellungen",
        "CONVERSATION_ASSIGNMENT": "Senden Sie E-Mail-Benachrichtigungen, wenn mir ein Gespräch zugewiesen wurde",
        "CONVERSATION_CREATION": "Senden Sie E-Mail-Benachrichtigungen, wenn eine neue Konversation erstellt wird",
        "CONVERSATION_MENTION": "Senden Sie E-Mail-Benachrichtigungen, wenn Sie in einer Konversation erwähnt werden",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Senden Sie E-Mail-Benachrichtigungen, wenn eine neue Nachricht in einer zugewiesenen Konversation erstellt wird",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "E-Mail-Benachrichtigungen senden, wenn eine neue Nachricht in einer zugewiesenen Konversation erstellt wird",
        "SLA_MISSED_FIRST_RESPONSE": "Senden Sie E-Mail-Benachrichtigungen, wenn eine Konversation die erste Antwort-SLA verpasst",
        "SLA_MISSED_NEXT_RESPONSE": "Senden Sie E-Mail-Benachrichtigungen, wenn eine Konversation die nächste Antwort-SLA verpasst",
        "SLA_MISSED_RESOLUTION": "Senden Sie E-Mail-Benachrichtigungen, wenn eine Konversation die Lösung-SLA verpasst"
      },
      "NOTIFICATIONS": {
        "TITLE": "Benachrichtigungseinstellungen",
        "TYPE_TITLE": "Benachrichtigungsart",
        "EMAIL": "E-Mail",
        "PUSH": "Push-Benachrichtigung",
        "TYPES": {
          "CONVERSATION_CREATED": "Eine neue Konversation wurde erstellt",
          "CONVERSATION_ASSIGNED": "Eine Konversation wurde Ihnen zugewiesen",
          "CONVERSATION_MENTION": "Sie wurden in einer Konversation erwähnt",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Eine neue Nachricht wurde in einer zugewiesenen Konversation erstellt",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Eine neue Nachricht wurde in einer Konversation erstellt, an der Sie teilnehmen",
          "SLA_MISSED_FIRST_RESPONSE": "Eine Konversation verpasst die erste Antwort-SLA",
          "SLA_MISSED_NEXT_RESPONSE": "Eine Konversation verpasst die nächste Antwort-SLA",
          "SLA_MISSED_RESOLUTION": "Eine Konversation verpasst die Lösungs-SLA",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Eine neue Nachricht wurde in einer Unterhaltung ohne verfügbaren Agenten erstellt"
        },
        "BROWSER_PERMISSION": "Aktivieren Sie Push-Benachrichtigungen für Ihren Browser, damit Sie diese empfangen können",
        "ALLOW_NOTIFICATION_DURING_CALL": "Push-Benachrichtigungen während eines Anrufs zulassen",
        "TEST_PUSH": "Test",
        "TESTING": "Test läuft...",
        "TEST_PUSH_DESCRIPTION": "Test-Benachrichtigungen senden, um Ihre Einrichtung zu überprüfen",
        "TEST_NOTIFICATION_ERROR": "Test-Benachrichtigung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
        "TEST_LOCAL_TITLE": "Test-Benachrichtigung (Lokal)",
        "TEST_LOCAL_BODY": "Dies ist eine lokale Browser-Benachrichtigung. Wenn Sie dies sehen, funktionieren Browser-Benachrichtigungen!"
      },
      "API": {
        "UPDATE_SUCCESS": "Ihre Benachrichtigungseinstellungen wurden erfolgreich aktualisiert",
        "UPDATE_ERROR": "Beim Aktualisieren der Einstellungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push-Benachrichtigungen",
        "NOTE": "Aktualisieren Sie hier Ihre Push-Benachrichtigungseinstellungen",
        "CONVERSATION_ASSIGNMENT": "Push-Benachrichtigungen senden, wenn mir ein Gespräch zugewiesen wird",
        "CONVERSATION_CREATION": "Push-Benachrichtigungen senden, wenn eine neue Konversation startet",
        "CONVERSATION_MENTION": "Senden Sie Push-Benachrichtigungen, wenn Sie in einer Konversation erwähnt werden",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Senden Sie Push-Benachrichtigungen, wenn eine neue Nachricht in einer zugewiesenen Konversation erstellt wird",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Sende Push-Benachrichtigungen, wenn eine neue Nachricht in einer zugewiesenen Konversation erstellt wird",
        "HAS_ENABLED_PUSH": "Sie haben die Push-Benachrichtigung für diesen Browser aktiviert.",
        "REQUEST_PUSH": "Push-Benachrichtigungen aktivieren",
        "SLA_MISSED_FIRST_RESPONSE": "Senden Sie Push-Benachrichtigungen, wenn eine Konversation die erste Antwort-SLA verpasst",
        "SLA_MISSED_NEXT_RESPONSE": "Senden Sie Push-Benachrichtigungen, wenn eine Konversation die nächste Antwort-SLA verpasst",
        "SLA_MISSED_RESOLUTION": "Senden Sie Push-Benachrichtigungen, wenn eine Konversation die Lösungs-SLA verpasst"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilbild"
      },
      "NAME": {
        "LABEL": "Ihr vollständiger Name",
        "ERROR": "Bitte geben Sie einen gültigen Namen ein",
        "PLACEHOLDER": "Bitte geben Sie Ihren Namen ein, dies wird in Gesprächen angezeigt"
      },
      "DISPLAY_NAME": {
        "LABEL": "Anzeigename",
        "ERROR": "Bitte geben Sie einen gültigen Anzeigenamen ein",
        "PLACEHOLDER": "Bitte geben Sie einen Anzeigenamen ein, dieser wird in Unterhaltungen angezeigt"
      },
      "AVAILABILITY": {
        "LABEL": "Verfügbarkeit",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Beschäftigt",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Verfügbarkeit wurde erfolgreich gesetzt",
        "SET_AVAILABILITY_ERROR": "Verfügbarkeit konnte nicht gesetzt werden, bitte versuchen Sie es erneut"
      },
      "EMAIL": {
        "LABEL": "Deine Emailadresse",
        "ERROR": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "PLACEHOLDER": "Bitte geben Sie Ihre E-Mail-Adresse ein, diese wird in Gesprächen angezeigt"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Aktuelles Passwort",
        "ERROR": "Bitte geben Sie das aktuelle Passwort ein",
        "PLACEHOLDER": "Bitte geben Sie das aktuelle Passwort ein"
      },
      "PASSWORD": {
        "LABEL": "Passwort zurücksetzen",
        "ERROR": "Bitte geben Sie ein Passwort mit einer Länge von 6 oder mehr ein",
        "PLACEHOLDER": "Bitte geben Sie ein neues Passwort ein"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Bestätige neues Passwort",
        "ERROR": "Bestätigen Sie, dass das Passwort mit dem Passwort übereinstimmen sollte",
        "PLACEHOLDER": "Bitte geben Sie Ihr Passwort erneut ein"
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatisch zur nächsten Unterhaltung navigieren",
        "NOTE": "Nach dem Lösen der aktuellen Unterhaltung automatisch zur nächsten offenen wechseln",
        "UPDATE_SUCCESS": "Einstellung für automatische Navigation erfolgreich aktualisiert"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "E-Mail-Vorschauformat in der Unterhaltungsliste",
        "NOTE": "Wählen Sie aus, was in der Unterhaltungsliste für Unterhaltungen aus E-Mail-Postfächern angezeigt wird",
        "SUBJECT": "Betreff",
        "SUBJECT_WITH_NOTE": "Betreff und letzte Nachricht, wenn es sich um eine private Notiz handelt",
        "UPDATE_SUCCESS": "Einstellung für die E-Mail-Vorschau erfolgreich aktualisiert"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Tastenkombinationen deaktivieren",
        "NOTE": "Alle Tastenkombinationen in der gesamten Anwendung deaktivieren",
        "UPDATE_SUCCESS": "Einstellung für Tastenkombinationen erfolgreich aktualisiert"
      },
      "FOLDER_ORDER": {
        "TITLE": "Ordnerreihenfolge",
        "NOTE": "Passen Sie die Reihenfolge an, in der Ordner (benutzerdefinierte Ansichten) in der Seitenleiste erscheinen. Ziehen und ablegen zum Neuordnen.",
        "NO_FOLDERS": "Keine benutzerdefinierten Ordner gefunden. Erstellen Sie Ordner, um Ihre Unterhaltungen zu organisieren."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Seitenleiste konfigurieren",
        "NOTE": "Passen Sie an, welche Abschnitte in der Unterhaltungs-Seitenleiste erscheinen.",
        "SAVE_BUTTON": "Konfiguration speichern",
        "UPDATE_SUCCESS": "Seitenleisten-Konfiguration erfolgreich aktualisiert",
        "UPDATE_ERROR": "Beim Aktualisieren der Seitenleisten-Konfiguration ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Alle Unterhaltungen",
          "ALL_CONVERSATIONS_DESC": "Menüpunkt \"Alle Unterhaltungen\" in der Seitenleiste anzeigen",
          "INBOX": "Posteingang",
          "INBOX_DESC": "Hauptposteingang mit ungelesenen Benachrichtigungen anzeigen",
          "CONVERSATION_GROUPS": "Erwähnungen und Unbeaufsichtigt",
          "CONVERSATION_GROUPS_DESC": "Gruppen für Erwähnungen und unbeaufsichtigte Unterhaltungen anzeigen",
          "FOLDERS": "Ordner",
          "FOLDERS_DESC": "Benutzerdefinierte Ansichten (Ordner) für organisierte Unterhaltungen anzeigen",
          "TEAMS": "Teams",
          "TEAMS_DESC": "Unterhaltungen gefiltert nach Team-Zuweisungen anzeigen",
          "CHANNELS": "Posteingänge",
          "CHANNELS_DESC": "Unterhaltungen gefiltert nach Posteingang anzeigen",
          "LABELS": "Labels",
          "LABELS_DESC": "Unterhaltungen gefiltert nach Labels anzeigen"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefoneinstellungen",
        "NOTE": "Geben Sie die Anmeldedaten Ihres PBX-Systems ein.",
        "USERNAME": "Benutzername",
        "PASSWORD": "Passwort",
        "SUBMIT": "Speichern",
        "USERNAME_INVALID": "Der Benutzername darf nur Buchstaben, Ziffern und . _ - + enthalten — keine Leerzeichen und keine E-Mail-Adresse.",
        "API": {
          "USERNAME_INVALID": "Der Benutzername ist kein gültiger SIP-Benutzername. Verwenden Sie nur Buchstaben, Ziffern und . _ - + — keine Leerzeichen und keine E-Mail-Adresse.",
          "USERNAME_TAKEN": "Dieser Benutzername wird bereits von einem anderen Agenten in diesem Konto verwendet."
        }
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome-Erweiterung",
        "NOTE": "Installieren Sie unsere Chrome-Erweiterung, um umfangreiche Benachrichtigungen zu eingehenden Anrufen zu erhalten.",
        "INSTALL_BUTTON": "Erweiterung installieren",
        "ALREADY_INSTALLED": "Erweiterung installiert"
      },
      "POSITION": {
        "LABEL": "Position",
        "ERROR": "Bitte geben Sie eine gültige Position ein",
        "PLACEHOLDER": "Bitte geben Sie Ihre Position ein"
      },
      "CUSTOM_LINE": {
        "LABEL": "Benutzerdefinierte Zeile",
        "ERROR": "Bitte geben Sie eine gültige benutzerdefinierte Zeile ein",
        "PLACEHOLDER": "Bitte geben Sie Ihre benutzerdefinierte Zeile ein"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Ändern",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "SELECTOR_SUBTITLE": "Wählen Sie ein Benutzerkonto aus der folgenden Liste",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out",
    "REPORT_BUG": "Fehler melden"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "Tage der Testversion verbleibend.",
    "TRAIL_BUTTON": "Jetzt kaufen",
    "DELETED_USER": "Gelöschter Benutzer",
    "EMAIL_VERIFICATION_PENDING": "Es scheint, dass Sie Ihre E-Mail-Adresse noch nicht verifiziert haben. Bitte überprüfen Sie Ihren Posteingang auf die Verifizierungs-E-Mail.",
    "RESEND_VERIFICATION_MAIL": "Verifizierungs-E-Mail erneut senden",
    "EMAIL_VERIFICATION_SENT": "Verifizierungs-E-Mail wurde versendet. Bitte überprüfen Sie Ihren Posteingang.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Konto gesperrt",
      "MESSAGE": "Ihr Account wurde gesperrt. Wenden Sie sich für weitere Informationen bitte an das Support-Team."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopieren",
      "CODEPEN": "In CodePen öffnen",
      "COPY_SUCCESSFUL": "Code erfolgreich in die Zwischenablage kopiert"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mehr zeigen",
      "SHOW_LESS": "Weniger zeigen"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Herunterladen",
      "UPLOADING": "Wird hochgeladen...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Diese Geschichte ist nicht mehr verfügbar.",
      "RECORDING_UNAVAILABLE": "Diese Aufnahme ist nicht mehr verfügbar.",
      "DELETE_RECORDING": {
        "BUTTON": "Anrufaufzeichnung löschen",
        "TITLE": "Anrufaufzeichnung löschen?",
        "DESCRIPTION": "Alle Aufzeichnungen dieses Anrufs werden dauerhaft aus der Telefonanlage gelöscht und können nicht wiederhergestellt werden. Transkript und Zusammenfassung des Anrufs bleiben erhalten.",
        "CONFIRM": "Löschen",
        "SUCCESS": "Anrufaufzeichnung gelöscht",
        "ERROR": "Die Anrufaufzeichnung konnte nicht gelöscht werden. Bitte versuchen Sie es erneut."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Auf Karte ansehen"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Abschicken"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Überprüfen...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Posteingang hinzufügen"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Wird gerade angezeigt:",
    "SWITCH": "Wechseln",
    "INBOX_VIEW": "Posteingangsansicht",
    "CONVERSATIONS": "Gespräche",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Alle Konversationen",
    "MENTIONED_CONVERSATIONS": "Erwähnungen",
    "PARTICIPATING_CONVERSATIONS": "Beteiligt",
    "UNATTENDED_CONVERSATIONS": "Unbeaufsichtigt",
    "REPORTS": "Berichte",
    "SETTINGS": "Einstellungen",
    "CONTACTS": "Kontakte",
    "CAPTAIN": "Kapitän",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Hauptseite",
    "AGENTS": "Agenten",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit-Protokolle",
    "INBOXES": "Posteingänge",
    "NOTIFICATIONS": "Push-Benachrichtigungen",
    "CANNED_RESPONSES": "Vorgefertigte Antworten",
    "INTEGRATIONS": "Integrationen",
    "PROFILE_SETTINGS": "Profileinstellungen",
    "ACCOUNT_SETTINGS": "Kontoeinstellungen",
    "APPLICATIONS": "Anwendungen",
    "LABELS": "Labels",
    "CUSTOM_ATTRIBUTES": "Benutzerdefinierte Attribute",
    "AUTOMATION": "Automatisierung",
    "MACROS": "Makros",
    "TEAMS": "Teams",
    "BILLING": "Rechnungen",
    "CUSTOM_VIEWS_FOLDER": "Ordner",
    "CUSTOM_VIEWS_SEGMENTS": "Segmente",
    "ALL_CONTACTS": "Alle Kontakte",
    "TAGGED_WITH": "Markiert mit",
    "NEW_LABEL": "Neues Label",
    "NEW_TEAM": "Neues Team",
    "NEW_INBOX": "Neuer Posteingang",
    "REPORTS_CONVERSATION": "Gespräche",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampagnen",
    "ONGOING": "Im Gange",
    "ONE_OFF": "Einmalig",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenten",
    "REPORTS_LABEL": "Labels",
    "REPORTS_INBOX": "Posteingang",
    "REPORTS_TEAM": "Team",
    "SET_AVAILABILITY_TITLE": "Setzen Sie sich als",
    "SET_YOUR_AVAILABILITY": "Legen Sie Ihre Verfügbarkeit fest",
    "AVAILABILITY_IMPERSONATING": "Gesperrt, solange Sie als dieser Benutzer angemeldet sind",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Übersicht",
    "REAUTHORIZE": "Ihre Posteingangsverbindung ist abgelaufen. Bitte erneut verbinden,\n um weiterhin Nachrichten empfangen und senden zu können",
    "HELP_CENTER": {
      "TITLE": "Hilfezentrum",
      "ARTICLES": "Articles",
      "CATEGORIES": "Kategorien",
      "LOCALES": "Sprachen",
      "SETTINGS": "Einstellungen",
      "DICTIONARY": "Wörterbuch"
    },
    "CHANNELS": "Kanäle",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automatisch offline markieren",
      "INFO_TEXT": "Lassen Sie sich vom System automatisch als offline markieren, wenn Sie die App oder das Dashboard nicht verwenden.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Dokumente lesen",
    "DATA_ASSISTANT": "Daten-Assistent",
    "WHATSAPP_TEMPLATES": "WhatsApp-Vorlagen",
    "BLOCKED_DOMAINS": "SPAM",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Übersicht",
    "WALLBOARD_QUEUES": "Warteschlangen",
    "WALLBOARD_AGENTS": "Agentenübersicht",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Berichte",
    "NO_WAITING_CALLERS": "keine wartenden Anrufer",
    "WAITING_CALLERS": "{count} wartende Anrufer",
    "NEW_CONVERSATION": "Neue Unterhaltung",
    "DRAFT": "Entwurf"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Rechnungen",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Derzeitiger Plan",
      "PLAN_NOTE": "Sie haben derzeit den Tarif **{plan}** mit **{quantity}** Lizenzen abonniert",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Abonnement verwalten",
      "DESCRIPTION": "Zeigen Sie Ihre vorherigen Rechnungen an, bearbeiten Sie Ihre Rechnungsdaten oder kündigen Sie Ihr Abonnement.",
      "BUTTON_TXT": "Gehen Sie zum Abrechnungsportal"
    },
    "CAPTAIN": {
      "TITLE": "Kapitän",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Brauchen Sie Hilfe?",
      "DESCRIPTION": "Haben Sie Probleme bei der Abrechnung? Wir sind hier um zu helfen.",
      "BUTTON_TXT": "Chatten Sie mit uns"
    },
    "NO_BILLING_USER": "Ihr Rechnungskonto wird konfiguriert. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Oh oh! Wir konnten keine Konten finden. Bitte erstellen Sie ein neues Konto, um fortzufahren.",
    "NEW_ACCOUNT": "Neuer Account",
    "SELECTOR_SUBTITLE": "Neuen Account erstellen",
    "API": {
      "SUCCESS_MESSAGE": "Benutzerkonto erfolgreich erstellt",
      "EXIST_MESSAGE": "Benutzerkonto existiert bereits",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Firmenname",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Abschicken",
      "CANCEL": "Abbrechen"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Alle Verknüpfungen anzeigen",
    "TITLE": {
      "OPEN_CONVERSATION": "Unterhaltung öffnen",
      "RESOLVE_AND_NEXT": "Lösen und zum Nächsten gehen",
      "NAVIGATE_DROPDOWN": "Dropdown-Elemente navigieren",
      "RESOLVE_CONVERSATION": "Unterhaltung als gelöst kennzeichnen",
      "GO_TO_CONVERSATION_DASHBOARD": "Zur Konversationsübersicht gehen",
      "ADD_ATTACHMENT": "Anhang hinzufügen",
      "GO_TO_CONTACTS_DASHBOARD": "Zur Kontaktübersicht",
      "TOGGLE_SIDEBAR": "Seitenleiste umschalten",
      "GO_TO_REPORTS_SIDEBAR": "Zur Berichtsseitenleiste",
      "MOVE_TO_NEXT_TAB": "Zum nächsten Tab in der Konversationsliste gehen",
      "GO_TO_SETTINGS": "Zu den Einstellungen",
      "SWITCH_TO_PRIVATE_NOTE": "Zu privaten Notizen wechseln",
      "SWITCH_TO_REPLY": "Zur Antwort wechseln",
      "TOGGLE_SNOOZE_DROPDOWN": "Schlummer-Dropdown ein-/ausblenden",
      "AI_ASSIST_MENU": "KI-Unterstützung",
      "AI_ASSIST_GRAMMAR": "Grammatik korrigieren",
      "AI_ASSIST_UNIFY_LANG": "Nachrichtensprache vereinheitlichen"
    }
  },
  "BUG_REPORT": {
    "TITLE": "Fehler melden",
    "DESCRIPTION_LABEL": "Problembeschreibung",
    "DESCRIPTION_PLACEHOLDER": "Beschreiben Sie das aufgetretene Problem...",
    "SUBMIT": "Meldung absenden",
    "SUBMITTING": "Wird gesendet...",
    "CANCEL": "Abbrechen",
    "SUCCESS": "Fehlerbericht erfolgreich eingereicht. Vielen Dank!",
    "ERROR": "Fehlerbericht konnte nicht eingereicht werden. Bitte versuchen Sie es erneut.",
    "VALIDATION_ERROR": "Bitte beschreiben Sie das Problem, bevor Sie es absenden"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blockierte Domänen und Kontakte",
    "DESCRIPTION": "Liste der blockierten E-Mail-Domänen für dieses Konto.",
    "NO_BLOCKED_DOMAINS": "Keine blockierten Domänen gefunden.",
    "BLOCKED_CONTACTS_BTN": "Blockierte Kontakte"
  }
}
